<template>
  <transition name="fade">
    <div class="modal is-active" v-if="show">
      <div v-on:click="close" class="modal-background"></div>
      <div class="modal-container">
        <div class="modal-card" :class="[{'has-width-auto': props.setWidthAuto, 'modal-large': props.middleLarge, 'nps-rating-container': props.isNpsRating}]">
          <header class="modal-card-head">
            <p class="modal-card-title has-text-centered" :class="{ 'content-align-center': props.isReportSucsess || props.isReportReview }">{{ props.title }}</p>
            <button v-if="props.show_close_btn" @click.prevent="close" class="delete" aria-label="close"></button>
          </header>
          <section :class="['modal-card-body', { 'no-bottom-padding' : props.isReportReview || props.isUpdatePassword || props.isEditProfile }, { 'content-align-center': props.isReportSucsess }, { 'delete-review': props.deleteReview }]">

            <p class="margin-bottom-10 has-text-centered" v-html="props.body"></p>
            <button v-if="props.show_close_btn && props.isNpsRating" @click.prevent="close" class="delete close-modal-button" aria-label="close"></button>
            <!-- business switcher -->
            <ul v-if="props.radioOptions">
              <li v-for="option in props.radioOptions">
                <nav class="level is-mobile">
                  <div class="level-left">
                    <div v-if="option.image" class="level-item">
                      <figure class="media-left">
                        <p class="image is-32x32">
                          <img :src="option.image">
                        </p>
                      </figure>
                    </div>
                    <div class="level-item">
                      <p class="has-text-weight-light" v-text="option.name"></p>
                    </div>
                  </div>
                  <div class="level-right">
                    <div class="level-item column-checkbox">
                      <input type="radio" name="select_business" :value="option.id"
                             v-model="radio_selection"/>
                    </div>
                  </div>
                </nav>
              </li>
            </ul>

            <!-- renders a collection of form elements -->
            <div v-if="props.textInputFields">
              <div v-for="(fieldGroup, index) in props.textInputFields"
                   :class="['has-text-left', index, { 'margin-top-20':index > 0}]">
                <div class="field">
                  <label v-if="fieldGroup.value" v-text="fieldGroup.value"></label>
                </div>
                <div v-for="(field, index) in fieldGroup.fields" class="field padding-left-0 padding-right-0">
                  <div class="control">
                    <input v-if="props.task == 'addEmailAddress'"
                           type="text"
                           @change="inputChange($event)"
                           class="input"
                           :id="field.fieldName"
                           :name="field.fieldName"
                           :placeholder="field.placeholder"/>
                    <input v-else
                           type="text"
                           @change="inputChange($event)"
                           class="input"
                           :id="field.fieldName"
                           :name="field.fieldName"
                           :value="field.value"
                           :placeholder="field.placeholder"/>
                    <p class="help is-danger has-text-weight-normal" :ref="field.fieldName"></p>
                  </div>
                </div>
              </div>
            </div>

            <!-- mobile number renderer -->
            <div class="control margin-top-30"
                 v-if="props.form_element !== undefined && props.form_element.name === 'mobile_number'">
              <input
                type="text"
                class="input"
                :name="`${props.form_element.name}`"
                v-model="mobile_number"
                :placeholder="`${props.form_element.placeholder}`"/>
              <p class="help is-danger has-text-weight-normal" v-if="show_error">
                {{ props.form_element.error_msg }}</p>
            </div>

            <!-- Report review form elements -->
            <div v-if="props.isReportReview" class="report-modal">
              <div class="field">
                <label class="label">Why are you reporting this review?</label>
                <div class="control">
                  <label class="radio c-radio">
                    <input :disabled="is_loading" v-model="form.reason_id" type="radio" name="reason" value="5">
                    The review is for a different business
                  </label><br/>
                  <label class="radio c-radio">
                    <input :disabled="is_loading" v-model="form.reason_id" type="radio" name="reason" value="8">
                    The review is spam or a scam
                  </label><br/>
                  <label class="radio c-radio">
                    <input :disabled="is_loading" v-model="form.reason_id" type="radio" name="reason" value="4">
                    The review is defamatory
                  </label><br/>
                  <label class="radio c-radio">
                    <input :disabled="is_loading" v-model="form.reason_id" type="radio" name="reason" value="3">
                    The review is false or contains false information
                  </label><br/>
                  <label class="radio c-radio">
                    <input :disabled="is_loading" v-model="form.reason_id" type="radio" name="reason" value="6">
                    Other
                  </label>
                </div>
                <p v-if="form.errors.has('reason_id')" class="help is-danger">Please provide one of the options above</p>
              </div>

              <div class="field">
                <label class="label">Please give us more information to help us investigate:</label>
                <div class="control">
                  <textarea :disabled="is_loading" v-model="form.report_reason" class="textarea has-fixed-size hp-textarea" placeholder="Please give us more information to help us investigate"></textarea>
                </div>
                <p v-if="form.errors.has('report_reason')" class="help is-danger" v-html="form.errors.get('report_reason')"></p>
              </div>

              <div class="field">
                <label class="label">Your full name</label>
                <div class="control">
                  <input :disabled="is_loading" v-model="form.reporter_name" class="input hp-input" type="text" placeholder="Full name">
                </div>
                <p v-if="form.errors.has('reporter_name')" class="help is-danger" v-html="form.errors.get('reporter_name')"></p>
              </div>

              <div class="field">
                <label class="label">Email address</label>
                <div class="control">
                  <input :disabled="is_loading" v-model="form.reporter_email" class="input hp-input" type="email" placeholder="Email address">
                </div>
                <p v-if="form.errors.has('reporter_email')" class="help is-danger" v-html="form.errors.get('reporter_email')"></p>
              </div>

              <div class="field">
                <label class="label">Mobile number (optional)</label>
                <div class="control">
                  <input :disabled="is_loading" v-model="form.reporter_contact" class="input hp-input" type="tel" placeholder="Cell phone number">
                </div>
                <p v-if="form.errors.has('reporter_contact')" class="help is-danger" v-html="form.errors.get('reporter_contact')"></p>
              </div>
            </div>

            <!-- report a review submit button -->
            <button v-if="props.isReportReview" :class="['is-hidden-tablet button hp-btn-primary is-fullwidth', { 'is-loading': is_loading }]" v-on:click="reportReview"
                    v-html="props.btn_action_title"></button>

            <!-- Update password form elements -->
            <div id="updatePassword" v-if="props.isUpdatePassword">
              <!-- OLD PASSWORD -->
              <div class="field">
                <label class="label">Old password</label>
                <div class="control">
                  <vue-password :disabled="is_loading" v-model="updatePasswordForm.old_password" classes="input" :disableStrength="disableStrength" placeholder="Old password"></vue-password>
                </div>
                <p v-if="updatePasswordForm.errors.has('old_password')" class="help is-danger" v-html="updatePasswordForm.errors.get('old_password')"></p>
              </div>

              <!-- NEW PASSWORD -->
              <div class="field">
                <label class="label">New password</label>
                <div class="control">
                  <vue-password :disabled="is_loading" v-model="updatePasswordForm.new_password" classes="input" :disableStrength="disableStrength" placeholder="New password"></vue-password>
                </div>
                <p v-if="updatePasswordForm.errors.has('new_password')" class="help is-danger" v-html="updatePasswordForm.errors.get('new_password')"></p>
              </div>

              <!-- CONFIRM PASSWORD -->
              <div class="field">
                <label class="label">Confirm password</label>
                <div class="control">
                  <vue-password :disabled="is_loading" v-model="updatePasswordForm.confirm_new_password" classes="input" :disableStrength="disableStrength" placeholder="Confirm password"></vue-password>
                </div>
                <p v-if="updatePasswordForm.errors.has('confirm_new_password')" class="help is-danger" v-html="updatePasswordForm.errors.get('confirm_new_password')"></p>
              </div>

            </div>

            <!-- Update password submit button -->
            <button v-if="props.isUpdatePassword" :class="['is-hidden-tablet button is-button-blue is-fullwidth-mobile aaa is-mobile-report-a-review-button', { 'is-loading': is_loading }]" v-on:click="updatePassword"
                    v-html="props.btn_action_title"></button>


            <!-- Info Window elements -->
            <div id="infoWindow" v-if="props.isInfoWindow">
              {{ body }}
            </div>


            <!-- Edit profile -->
            <div v-if="props.isEditProfile">

              <div class="field">
                <label class="label">About me</label>
                <div class="control">
                  <textarea :disabled="is_loading || fetching_user_profile" v-model="editProfileForm.bio" :class="['textarea', 'has-fixed-size', { 'is-loading': fetching_user_profile } ]" placeholder="About me"></textarea>
                </div>
                <p v-if="editProfileForm.errors.has('bio')" class="help is-danger" v-html="editProfileForm.errors.get('bio')"></p>
              </div>

              <div class="field">
                <label class="label">First name</label>
                <div class="control">
                  <input :disabled="is_loading || fetching_user_profile" v-model="editProfileForm.first_name" :class="['input', { 'is-loading' : fetching_user_profile }]" type="text" placeholder="First name">
                </div>
                <p v-if="editProfileForm.errors.has('first_name')" class="help is-danger" v-html="editProfileForm.errors.get('first_name')"></p>
              </div>

              <div class="field">
                <label class="label">Last name</label>
                <div class="control">
                  <input :disabled="is_loading || fetching_user_profile" v-model="editProfileForm.last_name" :class="['input', { 'is-loading' : fetching_user_profile }]" type="text" placeholder="Last name">
                </div>
                <p v-if="editProfileForm.errors.has('last_name')" class="help is-danger" v-html="editProfileForm.errors.get('last_name')"></p>
              </div>

              <div class="field">
                <label class="label">Email address</label>
                <div class="control">
                  <input disabled v-model="editProfileForm.email" :class="['input', { 'is-loading' : fetching_user_profile }]" type="text" placeholder="Email address">
                </div>
              </div>

              <div class="field">
                <label class="label">Phone number</label>
                <div class="control">
                  <input disabled v-model="editProfileForm.mobile" :class="['input', { 'is-loading' : fetching_user_profile }]" type="text" placeholder="Phone number">
                </div>
              </div>

              <div class="field">
                <label class="label">Physical address</label>
                <div class="control">
                  <vue-google-autocomplete
                    id="address"
                    ref="address"
                    classname="input"
                    placeholder="Physical address"
                    :country="['za']"
                    v-model="editProfileForm.address"
                    v-on:placechanged="getAddressData"
                    v-on:no-results-found="invalidAddress"
                    v-on:blur="invalidAddress"
                    v-on:change="invalidAddress">
                  </vue-google-autocomplete>
                </div>
              </div>

            </div>

            <!-- Edit profile submit button -->
            <button v-if="props.isEditProfile" :class="['is-hidden-tablet button is-button-blue is-fullwidth-mobile aaa is-mobile-report-a-review-button', { 'is-loading': is_loading }]" v-on:click="updateProfile"
                    v-html="props.btn_action_title"></button>

            <!-- Rate Business modal -->
            <div v-if="props.isNpsRating" class="nps-rating">
              <label class="label">Would you recommend {{ props.business }} to a friend or colleague?</label>
              <p>Select a number beteen 0 and 10 to submit your response.</p>
              <div class="nps-wrapper">
                <div class="nps-inner-wrapper one">
                  <a v-for="index in 7" :key="index" @click.prevent="rateBusiness(index-1)">{{ index - 1 }}</a>
                  <div class="child-b">
                    <p>Not likely</p>
                    <span>(Not good enough)</span>
                  </div>
                </div>
                <div class="nps-inner-wrapper two">
                  <a v-for="(item, index) in [7, 8]" :key="index" @click.prevent="rateBusiness(item)">{{ item }}</a>
                  <div class="child-b">
                    <p>Likely</p>
                    <span>(They can do better)</span>
                  </div>
                </div>
                <div class="nps-inner-wrapper three">
                  <a v-for="(item, index) in [9, 10]" :key="index" @click.prevent="rateBusiness(item)">{{ item }}</a>
                  <div class="child-b">
                    <p>Absolutely</p>
                    <span>(They did great)</span>
                  </div>
                </div>
              </div>
            </div>

          </section>

          <!-- action buttons -->
          <footer :class="['modal-card-foot', { 'no-top-padding' : props.isReportReview || props.isUpdatePassword || props.isEditProfile, 'for-nps-rating': props.isNpsRating }, 'is-hidden-mobile']">
            <div v-if="!props.isReportReview && !props.isUpdatePassword && !props.isEditProfile && props.show_btns" class="level-item"
                 :class="[{ 'button-block': props.deleteReview},{ 'content-align-center': props.isReportSucsess }, { 'has-text-right': !props.isReportSucsess }]">
              <button v-if="props.show_cancel_btn" class="button is-button-large has-button-medium is-button-blue-outline" v-on:click="close">
                CANCEL
              </button>
              <button v-if="!props.hide_submit_btn" :class="[{'is-loading': is_loading}, 'button hp-btn-primary']" v-on:click="process">
                {{ props.btn_action_title }}
              </button>
            </div>
            <div v-if="props.isReportReview" class="level-item">
              <button :class="['button hp-btn-primary', { 'is-loading': is_loading }]" v-on:click="reportReview" v-html="props.btn_action_title"></button>
            </div>
            <div v-if="props.isUpdatePassword" class="level-item has-text-right">
              <button :class="['button is-button-blue is-fullwidth-mobile aaa', { 'is-loading': is_loading }]" v-on:click="updatePassword" v-html="props.btn_action_title"></button>
            </div>
            <div v-if="props.isEditProfile" class="level-item has-text-right">
              <button :class="['button is-button-blue is-fullwidth-mobile aaa', { 'is-loading': is_loading }]" v-on:click="updateProfile" v-html="props.btn_action_title"></button>
            </div>
          </footer>
          <footer :class="['modal-card-foot', { 'no-top-padding' : props.isReportReview || props.isUpdatePassword || props.isEditProfile, 'for-nps-rating': props.isNpsRating }, 'is-hidden-tablet', 'is-hidden-desktop']">
            <div class="level-item has-text-centered" v-if="props.show_cancel_btn && props.show_btns && !props.isReportReview && !props.isUpdatePassword && !props.isEditProfile">
              <button class="button is-button-blue is-fullwidth-mobile" v-on:click="process">
                {{ props.btn_action_title }}
              </button>
            </div>
            <div v-if="props.show_cancel_btn && props.show_btns && !props.isReportReview && !props.isUpdatePassword && !props.isEditProfile" class="level-item has-text-centered">
              <button class="button is-button-blue-outline is-fullwidth-mobile" v-on:click="close">
                CANCEL
              </button>
            </div>
            <button v-if="!props.show_cancel_btn && props.show_btns && !props.isReportReview && !props.isUpdatePassword && !props.isEditProfile" class="button hp-btn-primary is-fullwidth" v-on:click="process"
                    v-html="props.btn_action_title"></button>
          </footer>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
/* eslint-disable indent,no-new,no-undef */
import auth from '@/mixins/auth.js'
import axios from 'axios'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import ApiResource from '@/api/ApiResource'
import VuePassword from 'vue-password'

export default {
  name: 'Modal',
  components: {
    VuePassword,
    VueGoogleAutocomplete
  },
  mixins: [auth],
  data () {
    return {
      body: '',
      show: false,
      /**
       * properties include {
       * title - title of the modal window
       * body - content to display on the body of the modal
       * btn_action_title - name of the button other than cancel that needs to perform some processing in calling comp.
       * show_btns - flag to display buttons or not - good for display error messages.
       * }
       */
      props: {},
      radio_selection: 0,
      inputTextBinds: {},
      mobile_number: '',
      is_mobile_number_valid: false,
      is_email_address_valid: false,
      show_error: false,
      is_loading: false,
      form: new ApiResource({
        reason_id: '',
        report_reason: '',
        reporter_name: '',
        reporter_email: '',
        reporter_contact: '',
        businessSlug: ''
      }),
      updatePasswordForm: new ApiResource({
        old_password: '',
        new_password: '',
        confirm_new_password: ''
      }),
      disableStrength: true,
      fetching_user_profile: false,
      editProfileForm: new ApiResource({
        bio: '',
        first_name: '',
        last_name: '',
        email: '',
        mobile: '',
        address: ''
      }),
      rateBusinessForm: new ApiResource({
        nps_selection: '',
        review_slug: ''
      })
    }
  },
  updated () {
    // populate address field with props
    if (this.$refs.address !== undefined) {
      if (this.$refs.address[0] !== undefined) {
        this.$refs.address[0].update(this.editProfileForm.address)
      }
    }
  },
  created () {
    window.events.$on('modal', (props) => this.display(props))
  },
  watch: {
    radio_selection () {
      this.props['selectedRadioOption'] = this.radio_selection
    },
    show () {
      if (this.show && this.props.isEditProfile) {
        // treat this as a load/created method for edit Profile modal
        this.editProfileForm = new ApiResource({
          bio: '',
          first_name: '',
          last_name: '',
          email: '',
          mobile: '',
          address: ''
        })
        this.getUserProfileDefaultFields()
      } else if (this.show && this.props.isReportReview) {

        if (this.isLoggedIn) {
          const profile_id = localStorage.getItem('profile_id')
          if (typeof profile_id !== 'undefined' && profile_id !== null) {
            axios.get(`/consumer/user/${profile_id}/profile-for-edit`)
              .then(({data}) => {
                this.form.reporter_name = `${data.first_name} ${data.last_name}`
                this.form.reporter_email = data.email
                this.form.reporter_contact = data.mobile
              })
          }
        }
      }
    }
  },
  methods: {
    /**
     * Callback handler for using Google Maps Static API
     * @param {object} addressData address data
     * @param {object} placeResultData placeresult data
     * @param {number} id id of location
     * @returns {null}
     */
    getAddressData (addressData, placeResultData, id) {
      this.editProfileForm.address = this.inputTextBinds['billingAddress'] = placeResultData.formatted_address
      this.inputTextBinds['org_lng'] = addressData.longitude
      this.inputTextBinds['org_lat'] = addressData.latitude
    },
    /**
     * Callback handler when user entered an invalid address not found by Google
     *
     * @param {string|object} userAddress The representation of the address entered by the User
     *
     * @returns {null}
     */
    invalidAddress (userAddress) {
      if (typeof userAddress !== 'undefined' && typeof userAddress.name !== 'undefined') {
        this.editProfileForm.address = this.inputTextBinds['billingAddress'] = userAddress.name
      } else if (typeof userAddress !== 'undefined') {
        this.editProfileForm.address = this.inputTextBinds['billingAddress'] = userAddress
      } else {
        this.editProfileForm.address = this.inputTextBinds['billingAddress'] = this.$refs.address.autocompleteText
      }
    },
    /**
     * Displays notification message globally
     * @param {object} props an object of properties for modal to use for dynamic rendering of modal elements
     * @returns {void}
     */
    display (props) {
      this.show_error = false
      this.mobile_number = ''
      this.props = props

      if (props.radioOptions) {
        for (let i = 0; i < props.radioOptions.length; i++) {
          if (props.radioOptions[i]['selected']) {
            this.radio_selection = parseInt(props.radioOptions[i]['id'])
            break
          }
        }
      }
      if (props.textInputFields) {
        for (let fieldGroup of props.textInputFields) {
          for (let field of fieldGroup.fields) {
            const key = field.fieldName
            this.inputTextBinds[key] = field.value
          }
        }
      }
      this.show = true
    },
    close () {
      this.form = new ApiResource({
        reason_id: '',
        report_reason: '',
        reporter_name: '',
        reporter_email: '',
        reporter_contact: '',
        businessSlug: '',
      })
      this.updatePasswordForm = new ApiResource({
        old_password: '',
        new_password: '',
        confirm_new_password: ''
      })
      this.editProfileForm = new ApiResource({
        bio: '',
        first_name: '',
        last_name: '',
        email: '',
        mobile: '',
        address: ''
      })
      this.show = this.is_loading = false
      window.events.$emit('cancelOps', this.props)
    },
    /**
     * Validates a collection of email addresses
     * @return {boolean}
     */
    validateEmailForms () {
      for (let field in this.inputTextBinds) {
        let value = this.inputTextBinds[field]
        if (value !== '') {
          // verify email
          this.is_email_address_valid = this.verifyEmail(value)
          if (!this.is_email_address_valid) {
            this.$refs[field][0].innerHTML = 'Email address is not valid.'
            return false
          } else {
            this.$refs[field][0].innerHTML = ''
          }
        }
      }
      return true
    },
    process () {
      this.show = false
      if (this.props.textInputFields) {
        if (this.props.task === 'addEmailAddress') {
          if (this.validateEmailForms()) {
            window.events.$emit(this.props.task, this.inputTextBinds)
            this.inputTextBinds = {}
          } else {
            this.show = true
          }
        } else {
          window.events.$emit(this.props.task, this.inputTextBinds)
        }
      } else if (this.props.form_element) {
        // validation for mobile number
        if (this.props.form_element.name === 'mobile_number') {
          this.is_mobile_number_valid = this.verifyMobileNumber(this[this.props.form_element.name])
          if (this.is_mobile_number_valid) {
            this.show_error = false
            this.props.form_element.value = this[this.props.form_element.name]
            window.events.$emit(this.props.task, this.props)
          } else {
            this.show = true
            this.show_error = true
          }
        }
      } else if (this.props.deleteReview) {
        /**
         * Event for deleting the review from profile
         * @type {boolean}
         */
        this.show = this.is_loading = true
        this.deleteReview(`${this.props.businessSlug}/reviews/${this.props.reviewId}`)
          .then(({message}) => {
            this.show = this.is_loading = false
            window.events.$emit(this.props.task, {reviewId: this.props.reviewId, reviewIndex: this.props.reviewIndex})
          })
          .catch((error) => {
            flash(error.response.data.message, 'is-danger')
          })
      } else {
        window.events.$emit(this.props.task, this.props)
      }
    },
    inputChange (event) {
      this.$emit('changed', event.target)
      this.inputTextBinds[event.target.name] = event.target.value
    },
    reportReview () {
      const permalink = this.props.reviewSlug
      this.form.businessSlug = this.props.businessSlug
      this.is_loading = true
      this.form.send(`/consumer/reviews/${permalink}/report`)
        .then(({data}) => {
          this.form = new ApiResource({
            reason_id: '',
            report_reason: '',
            reporter_name: '',
            reporter_email: '',
            reporter_contact: '',
            businessSlug: ''
          })
          this.show = this.is_loading = false
          window.events.$emit('reportedReviewComplete', {
            body: 'You have successfully reported this review',
            header: 'is-success',
            data
          })
        })
        .catch((error) => {
          this.is_loading = false

          if (this.form.errors.getStatus() === 422) {
            this.form.errors.errors = this.form.errors.errors.errors
          }

          if (typeof error.message !== 'undefined' && error.success === false) {
            this.show = false
            window.events.$emit('reportedReviewComplete', {
              body: 'We could not capture your attempt to report this review at this time. Please try again later',
              header: 'is-danger'
            })
          }
        })
    },
    updatePassword () {
      const userUUID = this.props.profileUUID
      this.is_loading = true
      this.updatePasswordForm.send(`/consumer/user/${userUUID}/update-password`)
        .then(() => {
          this.updatePasswordForm = new ApiResource({
            old_password: '',
            new_password: '',
            confirm_new_password: ''
          })
          this.show = this.is_loading = false
          window.events.$emit('updatePasswordComplete', {
            body: 'Your password has been updated',
            header: 'is-success'
          })
        })
        .catch((error) => {
          this.is_loading = false
          if (typeof error.message !== 'undefined' && error.success === false) {
            this.show = false
            window.events.$emit('updatePasswordComplete', {
              body: 'We could not update your password at this time. Please try again later',
              header: 'is-danger'
            })
          }
        })
    },
    getUserProfileDefaultFields () {
      this.fetching_user_profile = true
      axios.get(`/consumer/user/${this.props.profileUUID}/profile-for-edit`)
        .then(({data}) => {
          this.fetching_user_profile = false
          this.editProfileForm = new ApiResource({
            bio: data.bio !== null ? data.bio.trim() : '',
            first_name: data.first_name !== null ? data.first_name.trim() : '',
            last_name: data.last_name !== null ? data.last_name.trim() : '',
            email: data.email !== null ? data.email.trim() : '',
            mobile: data.mobile !== null ? data.mobile.trim() : '',
            address: data.address !== null ? data.address.trim() : ''
          })
        })
        .catch((error) => {
          this.fetching_user_profile = false
        })
    },
    updateProfile () {
      this.is_loading = true
      const bio = this.editProfileForm.bio
      this.editProfileForm.send(`/consumer/user/${this.props.profileUUID}/update-profile`)
        .then(() => {
          this.show = this.is_loading = false
          window.events.$emit('updateProfileComplete', {
            body: 'Your profile has been updated',
            header: 'is-success',
            bio: bio
          })
        })
        .catch((error) => {
          this.is_loading = false
          if (typeof error.message !== 'undefined' && error.success === false) {
            this.show = false
            window.events.$emit('updateProfileComplete', {
              body: 'We could not update your profile at this time. Please try again later',
              header: 'is-danger'
            })
          }
        })
    },
    rateBusiness (rateNumber) {
      let data = {
        nps_selection: rateNumber,
        review_slug: this.props.reviewSlug
      }
      axios.post('/nps/review-feedback', data)
        .then(({data}) => {
          this.show = false
          window.events.$emit('rateBusinessComplete', {
            body: `Thank you for rating ${this.props.business}.`,
            header: 'is-success'
          })
        })
        .catch((error) => {
          this.show = false
          window.events.$emit('rateBusinessComplete', {
            body: 'We could not update your business rating. Please try again later',
            header: 'is-danger'
          })
        })
    },
    /**
     * Promise for deleting the review
     * @param {string} url
     * @returns {Promise}
     */
    deleteReview (url) {
      return new Promise((resolve, reject) => {
        axios.delete(url, {
          data: {
            deleteByUser: true
          }
        })
          .then(({data}) => {
            resolve(data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";

.modal-card-head, .modal-card-foot {
  border-bottom: none;
  border-right: none;
  border-left: none;
  border-radius: 0;
  text-align: center;
  background-color: #fff;
  display: block;
  padding: 20px 30px 20px 30px;
}

.modal-card-foot {
  border-top: none;
  padding: 30px;
}

.modal-card-body {
  text-align: left;
  font-weight: bold;
  background-color: #fff;
  font-size: .9em;
  padding: 30px;
}

.modal-card-head {
  border-top: 5px solid map-get($colors, 'blue-dark');
  background-color: #F5F5F5;
  color: #58595B;
  display: flex;
}

@media screen and (min-width: 768px), print {
  .modal-content, .modal-card {
    margin: 0 auto;
    /*max-height: calc(100vh - 40px);*/
    width: 468px;
  }

  .modal-content, .modal-card.modal-large {
    width: 768px;
  }

  .nps-rating-container .modal-card-foot {
    border: none !important;
  }
}

.level-item {
  display: block;
}

.modal-card-title {
  color: map-get($colors, 'blue-dark');
  font-weight: bold;
  font-size: 1.15rem;
}

section.modal-card-body > ul > li {
  margin-left: 32px;
  margin-right: 32px;
}

section.modal-card-body > ul > li {
  padding-bottom: 25px;
}

section.modal-card-body > ul > li:not(:last-child) {
  border-bottom: 1px solid #cccccc;
}

section.modal-card-body > ul > li:not(:first-child) {
  padding-top: 25px;
}

.column-checkbox {
  padding-top: 0 !important;
}

input[type="radio"]:not(.c-radio):checked {
  background-color: map-get($colors, 'blue-dark');
  border: 1px solid map-get($colors, 'blue-dark');
}

input[type="radio"]:not(.c-radio) {
  -webkit-appearance: none;
  -moz-appearance: none;
  display: inline-block;
  width: 18px;
  height: 18px;
  padding: 3px;
  background-clip: content-box;
  border: 1px solid #d5d3d3;
  background-color: #fff;
  border-radius: 50%;
  vertical-align: middle;
}

.level-left > .level-item:first-child {
  margin-right: 0 !important;
  margin-left: 20px;
}

.nps-rating-container .close-modal-button {
  display: none;
}

.button-block {
  display: inline;
}

@media screen and (max-width: 767px) {
  .nps-rating-container .modal-card-head {
    display: none;
  }

  .nps-rating-container .modal-card-foot {
    padding: 0px;
  }

  .nps-rating-container .close-modal-button {
    display: block;
    position: absolute;
    right: 5px;
    top: 30px;
  }

  .modal-background {
    background-color: #fff;
  }

  .modal-container {
    width: 100%;
    height: 100%;
  }

  .modal-card {
    margin: 0;
    max-height: 100%;
    /*max-height: calc(100vh - 0px);*/
  }

  .button:not(.hp-btn-primary) {
    width: 100%;
  }

  .nps-wrapper {
    flex-direction: column;
    overflow-x: hidden;
    margin-top: 15px !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }

  .nps-inner-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;

  }

  .nps-wrapper a {
    width: 70px;
    margin: 10px 0;
  }

  .one:after {
    height: 87% !important;
    width: 3px !important;
    right: 38% !important;
    top: 7%;
    left: inherit !important;
  }

  .two:after {
    height: 71% !important;
    width: 3px !important;
    right: 38% !important;
    top: 15%;
    left: inherit !important;
  }

  .three:after {
    height: 71% !important;
    width: 3px !important;
    right: 38% !important;
    top: 15%;
    left: inherit !important;
  }

  .child-b {
    bottom: inherit !important;
    top: 35%;
    right: -25%;
  }

}

@media screen and (max-width: 575px) {
  .one:after {
    right: 41% !important;
  }

  .two:after {
    right: 41% !important;
  }

  .three:after {
    right: 41% !important;
  }

  .child-b {
    right: -30%;
    font-size: 10px;
  }

  .nps-wrapper a {
    padding: 0px 0 !important;
    margin: 4px 0;
    width: 40px;
    font-size: 16px;
  }

  .nps-wrapper {
    margin-left: -45px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all .2s ease;
}

.fade-enter, .fade-leave-active, .fade-leave-to {
  transform: scale(1.1);
  opacity: 0;
}

.button:not(.hp-btn-primary) {
  border: 1px solid #31AAE1;
  border-radius: 0;
  background-color: #30AAE1;
  color: #ffffff;
  font-size: 0.85rem;
  /*padding: 1.3rem 2rem;*/
  height: 40px;
  line-height: 40px;
  padding: 0 4rem;
}

.hp-btn-primary:not(.is-fullwidth) {
  width: 234px;
}

.delete::before, .modal-close::before, .delete::after, .modal-close::after {
  background-color: map-get($colors, 'blue-dark');
}

.delete {
  background-color: transparent;
  border: 2px solid map-get($colors, 'blue-dark');
}

.modal-card-body {
  color: #58595B;
  font-weight: normal;
}

.label {
  color: #58595B;
  display: block;
  font-size: 0.9rem;
  font-weight: normal;
}

.input:not(.hp-input), .textarea:not(.hp-textarea) {
  background-color: white;
  border-color: #dbdbdb;
  border-radius: 0;
  color: #58595B;
  max-width: 100%;
  width: 100%;
  box-shadow: none;
  font-size: 0.9rem;
}

.input {
  height: 40px;
}

.field {
  margin-bottom: 30px;
}

input[type="radio"]:not(.c-radio) {
  margin-right: 8px;
}

.checkbox, .radio {
  font-size: 0.8rem;
}

.no-top-padding {
  padding-top: 0 !important;
}

.no-bottom-padding {
  padding-bottom: 0 !important;
}

.is-mobile-report-a-review-button {
  margin-bottom: 50px;
}

.VuePassword__Toggle {
  color: gray !important;
}

.nps-rating {
  text-align: center;
}

.nps-rating label {
  font-weight: 700;
}

.nps-wrapper {
  display: flex;
  margin-top: 35px;
  justify-content: center;
  position: relative;
  padding-bottom: 20px;
  margin-bottom: 20px;
}

.nps-wrapper a {
  background: red;
  color: #fff;
  padding: 6px 19px;
  margin-right: 10px;
  font-size: 20px;
}

.one {
  position: relative;
}

.one:after {
  position: absolute;
  content: ' ';
  height: 3px;
  width: 88%;
  background: #a2a3a5;
  bottom: -21px;
  left: 6%;
}

.two {
  position: relative;
}

.two:after {
  position: absolute;
  content: ' ';
  height: 3px;
  width: 58%;
  background: #a2a3a5;
  bottom: -21px;
  left: 20%;
}

.three {
  position: relative;
}

.three:after {
  position: absolute;
  content: ' ';
  height: 3px;
  width: 58%;
  background: #a2a3a5;
  bottom: -21px;
  left: 20%;
}

.one a {
  background: #EC2B46;
}

.two a {
  background: #F3A904;
}

.three a {
  background: #4BB55F;
}

.child-b {
  position: absolute;
  bottom: -67px;
  width: 100%;
  text-align: center;
}

.child-b p {
  font-weight: 700;
  font-size: 12px;
}

.child-b span {
  white-space: nowrap;
  font-size: 12px;
}

.content-align-center {
  display: flex !important;
  justify-content: center;
  text-align: center;
}

.report-review-link {
  text-decoration: underline;
}

.is-button-blue-outline {
  color: #31AAE1;
  background-color: #fff;
  border-color: #31AAE1;
}

.delete-review {
  padding-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue